module.exports = __webpack_public_path__ + "static/media/idpay.82fedd73.svg";